//package imports
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

//component imports
import otpImg from "../../assests/images/otpImage.webp"
import osanLogo from "../../assests/images/osanLogo1.webp"
import CustomButton from "../../utils/resuableComponents/CustomButton";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons'
import OtpInput from 'react-otp-input';
import { showToast } from "../../utils/constants/Toaster";
import { MobileOtpText,EmailOtpText } from "../../utils/TextInputUtils";
import { VerifyOtpApi,LoginApi } from "../../services/apiServices/PostServices";
import { storeData } from "../../utils/AsyncStorage";

const OtpVerification = (props) => {

    const [otp, setOtp] = useState('');
    const [disableButton,setDisableButton]=useState(true)
    const history = useHistory();
    const mobileNumber = props?.location?.state?.mobile_number
    const email = props?.location?.state?.email
    const initialTime = 2 * 60 * 1000;
    const [time, setTime] = useState(initialTime) 
    
   

    useEffect(() => {
        const intervalId = setInterval(() => {
          // Decrement time every millisecond
          setTime(prevTime => Math.max(prevTime - 1000, 0)); // Decrease by 10 milliseconds
        }, 1000);
    
        // Cleanup the interval when the component unmounts
        return () => clearInterval(intervalId);
      }, []); 


      const formatTime = (timeInMilliseconds) => {
        const minutes = Math.floor(timeInMilliseconds / (60 * 1000));
    const seconds = Math.floor((timeInMilliseconds % (60 * 1000)) / 1000);
    const formatSeconds = seconds < 10 ? `0${seconds}` : seconds
    return `0${minutes}:${formatSeconds}`;
      };


    useEffect(() => {
        if(otp != "" ){
            setDisableButton(false)
        }else{
            setDisableButton(true)
        } 
      }, [otp]);
    
    const handleVerifyOtp = async () => {
        setDisableButton(true)
        setOtp("")
       const  reqbody ={
            phone_number:mobileNumber,
            email:email,
            otp:otp
        }
        const res = await VerifyOtpApi("validateOTP", reqbody);
        if(res?.success){
            let objs = JSON.stringify(res?.data);
            await storeData("userInfo", objs);
            await storeData("accessToken", res?.token);
            await storeData("refresh_token",res?.refresh_token)
            res?.data?.role === 3 ?
            res?.data?.first_name != null ? 
            history.push('/customerPortal/myShares') :
            history.push({
                pathname : '/createProfile',
                state :{
                mobile_number : res?.data?.phone_number,
                email:res?.data?.email,
                encrypt_id:res?.data?.encrypt_id,
                info:res?.data,
                from:"createProfile"
                }
                } ) :
            history.push("/admin/adminDashboard")
        }else{
            showToast(3,res.message)
            console.log("res",res?.message)
        }
    }

    //function to handle back navigation 
    const handleBackNavigation = () => {
        history.push({
            pathname : '/login',
            state :{
            mobile_number : mobileNumber,
            email:email
            }
            } );
    }
    const arr = new Array(4).fill("-");

    //function to handle resend button 
    const handleResendButton = async () => {

        const reqbody = {
            phone_number : mobileNumber,
            email:email
          };
          const res = await LoginApi("login", reqbody);
          if(res?.success){
            showToast(1,res?.message)
            setTime(initialTime)
          }else{
            showToast(3,res?.message)
          }
    }

    return (
        <div class=" container-fluid p-0  ">
            <div class="col-12 d-flex flex-row">
                <div class="col-md-1">
                </div>
                <div class=" full-container d-flex col-md-5  ">
                    <div class="d-flex justify-content-end mt-4">
                        <img src={otpImg} class="img-fluid mx-4 mt-4 " alt="otpImg" />
                    </div>
                </div>
                <div class="d-flex flex-column col-md-5  justify-content-center align-items-center ">
               
                <div class="d-flex flex-column col-md-10  align-self-end">
                    <div class=" text-center">
                    <img src={osanLogo} class="img-fluid my-1" alt="Osan_logo" />
                    </div> 
                </div>
                    <div class="d-flex col-md-10 flex-column align-self-end  ">
                        <div class="d-flex flex-column align-items-center mx-4">
                            <h1>OTP Verification</h1>
                            {
                                mobileNumber !== "" ? 
                                <p class="text-center paraColor">{MobileOtpText} {mobileNumber}</p> :
                                <p class="text-center paraColor">{EmailOtpText} {email}</p>     
                             }
                        </div>
                        <div class="mx-4 my-2 align-self-center"  >
                            <OtpInput
                                value={otp}
                                onChange={setOtp}
                                inputType="number"
                                numInputs={4}
                                renderSeparator={<span class="mx-3"></span>}
                                renderInput={(props) => <input {...props} />}
                                inputStyle={{
                                    width: '46px',
                                    height:"40px",
                                    borderRadius:"8px",
                                    borderStyle:'solid'
                                    // Adjust the width as needed
                                   // height: '50px', // Adjust the height as needed
                                  }}
                            />

                        </div>
                        <div class="align-self-center">
                        <p>{formatTime(time)}</p>
                        </div>

                        {
                         time === 0 ? 
                         <div class="mx-4 my-2 align-self-center">
                         <p clas="paraColor Roboto-regular fs-2 " >Didn’t receive code?  <span class="text-primary cursorPointer" onClick={() => handleResendButton()} >Resend</span></p>
                     </div> :
                     null
                        }
                       
                        
                        <div class="text-center my-2 ">
                            <h4 class="fs-4 m-0">
                                <span class="cursorPointer gap-2"  onClick={() => handleBackNavigation()}>
                                <FontAwesomeIcon icon={faChevronLeft} /> 
                               
                                <span class="mx-2 paraColor" > Back To Log In</span>
                                </span> 
                            </h4>
                        </div>
                        <div class="mx-4 my-4 align-self-center ">
                            <CustomButton
                                children={"Verify"}
                                onClick={handleVerifyOtp}
                                disabled = {disableButton}
                            />
                        </div>
                    </div>
                </div>
                <div class="col-md-1">
                </div>
            </div>

        </div>

    )
}


export default OtpVerification